import { render, staticRenderFns } from "./TasksLayout.vue?vue&type=template&id=6adbf61a"
import script from "./TasksLayout.vue?vue&type=script&lang=js"
export * from "./TasksLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6adbf61a')) {
      api.createRecord('6adbf61a', component.options)
    } else {
      api.reload('6adbf61a', component.options)
    }
    module.hot.accept("./TasksLayout.vue?vue&type=template&id=6adbf61a", function () {
      api.rerender('6adbf61a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/layout/TasksLayout.vue"
export default component.exports